import OfferStateEnum, { getOfferState } from '@enums/offer-state-enum';

/**
 * Adds a ranking property to offers to exclude offers that are expired or closed from the ranking
 * @param {Array} offers - The offers to process.
 * @returns {Object} - The offers with a ranking component for valid offers.
 */
export default function rankOffers(offers) {
  let rank = 0;
  offers.forEach((offer) => {
    if (getOfferState(offer.status) !== OfferStateEnum.EXPIRED
      && getOfferState(offer.status) !== OfferStateEnum.CLOSED) {
      offer.ranking = rank;
      rank += 1;
    }
  });

  return offers;
}
